import { cn } from "admin-ui/utils/cn"
import { IconProps } from "."

export default function ChatBubbleLeftRight({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <g clipPath="url(#clip0_5334_167962)">
        <path
          d="M8.22222 5.55554H13.1111C13.8471 5.55554 14.4444 6.15288 14.4444 6.88888V10.8889C14.4444 11.6249 13.8471 12.2222 13.1111 12.2222H12.6667V14.4444L10.2222 12.2222H8.22222C7.48622 12.2222 6.88889 11.6249 6.88889 10.8889V6.88888C6.88889 6.15288 7.48622 5.55554 8.22222 5.55554Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.6107 3.33333C10.4133 2.56711 9.71733 2 8.88889 2H3.33333C2.35111 2 1.55556 2.79556 1.55556 3.77778V8.22311C1.55556 9.20444 2.352 10.0009 3.33333 10V12.6667L4.66667 11.2124"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5334_167962">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
